export const DEAL_FREEZE_EDUCATION_BANNER_EXPERIMENT =
  '545a3ae7-deal-freeze-education-banner'

export const DEAL_FREEZE_EDUCATION_BANNER_COMPONENT =
  'DealFreezeEducationBanner'

export const DEAL_FREEZE_EDUCATION_BANNER_CTA = 'DealFreezeEducationBannerCta'

export const DEAL_FREEZE_EDUCATION_BANNER_SENTINEL =
  'DealFreezeEducationBannerSentinel'

export const BANNER_PLACEMENT = {
  primary: 'primary',
  secondary: 'secondary'
} as const

export type DealFreezeEducationBannerPlacement =
  (typeof BANNER_PLACEMENT)[keyof typeof BANNER_PLACEMENT]
